import { format, parse, differenceInMonths } from "date-fns";

// 1カ月以上経過しているかどうかを判定する関数
export const isOlderThanOneMonth = (dateStr?: string): boolean => {
  if (!dateStr) return false;

  try {
    const parsedDate = parse(dateStr, "yyyy/MM/dd", new Date());
    const now = new Date();

    const formatted = format(parsedDate, "yyyy/MM/dd");
    if (formatted === "0001/01/01") return false;

    return differenceInMonths(now, parsedDate) >= 1;
  } catch {
    return false;
  }
};
